import { EntityRef, EntityRefWithUID, ServicePointIdReference } from 'src/app/shared/models/referenceData'

export type ServicePointGroup = Readonly<{
  service_point_group_uid: string
  service_point_group_name: string

  service_point_uid?: readonly string[] | null
  service_point_id_search?: string | null

  eldc_uid?: readonly string[] | null
  control_area_uid?: readonly string[] | null
  company_code?: readonly string[] | null
  delivery_class_uid?: readonly string[] | null
  cpnode_uid?: readonly string[] | null
  ldc_uid?: readonly string[] | null
  location_uid?: readonly string[] | null
  loss_class_uid?: readonly string[] | null
  meter_type_uid?: readonly string[] | null
  profile_class_uid?: readonly string[] | null
  retailer_uid?: readonly string[] | null
  service_point_source_uid?: readonly string[] | null
  supply_class_uid?: readonly string[] | null
  net_meter_rider_code?: readonly string[] | null
}>

export type ServicePointGroupWithRefs = Readonly<{
  service_point_group_uid: string
  service_point_group_name: string

  service_point_uid?: readonly ServicePointIdReference[]
  service_point_id_search?: string | null

  company_code?: readonly EntityRef[]
  control_area_uid?: readonly EntityRefWithUID[]
  cpnode_uid?: readonly EntityRefWithUID[]
  delivery_class_uid?: readonly EntityRefWithUID[]
  eldc_uid?: readonly EntityRefWithUID[]
  ldc_uid?: readonly EntityRefWithUID[]
  location_uid?: readonly EntityRefWithUID[]
  loss_class_uid?: readonly EntityRefWithUID[]
  meter_type_uid?: readonly EntityRefWithUID[]
  profile_class_uid?: readonly EntityRefWithUID[]
  retailer_uid?: readonly EntityRefWithUID[]
  service_point_source_uid?: readonly EntityRefWithUID[]
  supply_class_uid?: readonly EntityRefWithUID[]
}>

export type ServicePointGroupState = Omit<
  ServicePointGroupWithRefs,
  'service_point_group_uid' | 'service_point_group_name'
> & { service_point_group_name?: string | null }

export type ServicePointGroupNonEntityAttributes =
  | 'service_point_group_name'
  | 'service_point_uid'
  | 'service_point_id_search'

export type ServicePointGroupEntityAttribute = Exclude<keyof ServicePointGroupState, ServicePointGroupNonEntityAttributes>

export type ServicePointGroupUpsertRequest = Omit<
  ServicePointGroup,
  'service_point_group_uid'
>

export const servicePointGroupEntitiesList: ServicePointGroupEntityAttribute[] = [
  'company_code',
  'control_area_uid',
  'cpnode_uid',
  'delivery_class_uid',
  'eldc_uid',
  'ldc_uid',
  'location_uid',
  'loss_class_uid',
  'meter_type_uid',
  'profile_class_uid',
  'retailer_uid',
  'service_point_source_uid',
  'supply_class_uid',
  // 'net_meter_rider_code'
]

export const servicePointGroupisplayedFiltersList: (keyof ServicePointGroup)[] = [
  ...servicePointGroupEntitiesList,
  'service_point_uid',
  'service_point_id_search',
]